import {
    FOLLOW_USER,
    UNFOLLOW_USER,
    UPDATE_ALL_USER_LIST
} from "@/store/actions.type"

import {
    UPDATE_ACTIVE_PROFILE
} from "@/store/mutations.type"

export default {
    data: () => ({
        followUpdating: false
    }),

    methods: {
        follow(userId) {
            if (this.followUpdating) return
            if (!this.isLogedIn) {
                this.$router.push('/account/login/')
                return
            }

            this.followUpdating = true
            this.$store.dispatch(FOLLOW_USER, {
                    userId: userId
                })
                .then(() => {
                    this.followUpdating = false

                    this.$store.dispatch(UPDATE_ALL_USER_LIST, {
                        userId: userId,
                        value: {
                            following: true
                        }
                    })

                    const activeProfile = this.$store.state.profile.activeProfile
                    if (activeProfile.id === userId) {
                        this.$store.commit(UPDATE_ACTIVE_PROFILE, { // active other profiles
                            following: true,
                            followers_count: activeProfile.followers_count + 1,
                        })
                    } else if (activeProfile.id === this.user.id) { // active user profile
                        this.$store.commit(UPDATE_ACTIVE_PROFILE, {
                            following_count: activeProfile.following_count + 1,
                        })
                    }
                })
        },

        unFollow(userId) {
            if (this.followUpdating) return
            this.followUpdating = true
            this.$store.dispatch(UNFOLLOW_USER, {
                    userId: userId
                })
                .then(() => {
                    this.followUpdating = false

                    this.$store.dispatch(UPDATE_ALL_USER_LIST, {
                        userId: userId,
                        value: {
                            following: false
                        }
                    })

                    const activeProfile = this.$store.state.profile.activeProfile
                    if (activeProfile.id === userId) {
                        this.$store.commit(UPDATE_ACTIVE_PROFILE, { // active other profiles
                            following: false,
                            followers_count: activeProfile.followers_count - 1,
                        })
                    } else if (activeProfile.id === this.user.id) { // active user profile
                        this.$store.commit(UPDATE_ACTIVE_PROFILE, {
                            following_count: activeProfile.following_count - 1,
                        })
                    }
                })
        }
    }

}